<ng-container *transloco="let t">
  <div class="flex h-full w-full flex-col">
    <div class="shrink-0 border-b border-gray-200 px-3 py-2">
      <app-bulk-upload-stepper [currentStep]="step()" />
    </div>
    <div class="flex-1 p-5">
      @if (bulkFlowState().step === "upload") {
        <div
          class="flex h-full w-full flex-col items-center justify-center rounded-xl border border-dashed border-gray-200 p-4"
        >
          <app-bulk-upload-file
            class="h-full w-full"
            [fileMetadata]="fileMetadata()"
            (upload)="upload($event)"
            (uploadPlainText)="uploadPlainText($event)"
            (preview)="preview()"
            (removeFile)="removeFile()"
            (export)="export()"
          />
        </div>
      } @else if (bulkFlowState().step === "preview") {
        <div class="flex h-full w-full items-center justify-center">
          @if (bulkFlowState().loading) {
            <div class="flex gap-2">
              <ISpinner [display]="true" />
              <span class="text-sm text-gray-500">{{ t("bulk-upload.preparing_your_preview") }}</span>
            </div>
          } @else if (previewBuckets(); as buckets) {
            <app-bulk-upload-preview
              class="h-full w-full"
              [previewBuckets]="buckets"
              [columnDefs]="previewColumnDefs"
              (back)="backToUpload()"
              (upload)="run()"
            />
          }
        </div>
      } @else if (bulkFlowState().step === "run") {
        <div class="flex h-full w-full flex-col items-center justify-center gap-4">
          <app-bulk-upload-run-progress class="w-full" [progress]="progress()" />
          @if (bulkFlowState().loading) {
            <div class="h-full w-full rounded-xl border border-dashed border-gray-200"></div>
          } @else if (runResult(); as runResult) {
            <app-bulk-upload-run
              class="h-full w-full"
              [runResult]="runResult"
              [columnDefs]="runResultColumnDefs"
              (closeImport)="closeImport()"
            />
          }
        </div>
      }
    </div>
  </div>
</ng-container>
